




import echarts, { EChartOption } from 'echarts'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import ResizeMixin from './mixins/resize'
export interface IBarChartData {
  actualData: any[]
}
@Component({
  name: 'BarChart',
})
export default class extends mixins(ResizeMixin) {
  @Prop({ required: true }) private chartTitle!: string
  @Prop({ default: 'chart' }) private className!: string
  @Prop({ default: '100%' }) private width!: string
  @Prop({ default: '350px' }) private height!: string
  @Prop({ required: true }) private dataCharts
  @Prop({}) public hasSearch: boolean | undefined

  @Watch('dataChart', { deep: true })
  private onChartDataChange(value: IBarChartData) {
    this.setOptions(value)
  }
  // tslint:disable-next-line:member-ordering
  public mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  }
  // tslint:disable-next-line:member-ordering
  public beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  }
  private initChart() {
    this.chart = echarts.init(this.$el as HTMLDivElement, 'macarons')
    this.setOptions(this.dataCharts)
  }

  private get userData() {
    const array: any = []
    for (const item of this.dataCharts) {
      array.push(item.totalUserVisit)
    }
    return array
  }

  private get userDataPercentage() {
    const array: any = []
    for (const item of this.dataCharts) {
      array.push(item.percentage.toFixed(2))
    }
    return array
  }

  private get userDataAccess() {
    const array: any = []
    for (const item of this.dataCharts) {
      array.push(item.totalUserAccess)
    }
    return array
  }

  private get getDay() {
    const array: any = []
    for (const item of this.dataCharts) {
      array.push(item.month)
    }
    return array
  }
  private setOptions(dataChart: IBarChartData) {
    if (this.chart) {
      this.chart.setOption({
        title: {
          left: 'center',
          text: 'SFID Training Material Ratio',
        },
        xAxis: [
          {
            data: this.getDay,
            boundaryGap: true,
            gridIndex: 1,
            axisTick: {
              show: false,
            },
          },
          {
            data: this.getDay,
            gridIndex: 0,
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
          },
        ],
        grid: [
          {
            left: 0,
            right: 50,
            bottom: 30,
            top: 240,
            containLabel: true,
          },
          {
            left: 32,
            right: 50,
            bottom: 170,
            top: 40,
            containLabel: false,
          },
        ],
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'none',
          },
        },
        yAxis: [
          {
            gridIndex: 1,
            axisTick: {
              show: false,
            },
          },
          {
            gridIndex: 0,
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
            },
            axisLabel: {
              show: true,
              formatter: '{value} %',
            },
          },
        ],
        legend: {
          bottom: 'bottom',
          data: ['Total Access User', 'Total User Visit', 'Percentage'],
        },

        series: [
          {
            name: 'Total Access User',
            type: 'bar',
            xAxisIndex: 0,
            yAxisIndex: 0,
            barGap: 0,
            itemStyle: {
              color: 'red',
              lineStyle: {
                color: 'red',
                width: 2,
              },
              areaStyle: {
                color: 'red',
              },
            },
            data: this.userDataAccess,
            animationDuration: 8000,
            animationEasing: 'quadraticOut',
          },
          {
            name: 'Total User Visit',
            type: 'bar',
            xAxisIndex: 0,
            yAxisIndex: 0,
            barCategoryGap: '30%',
            itemStyle: {
              color: 'grey',
              lineStyle: {
                color: 'grey',
                width: 2,
              },
              areaStyle: {
                color: 'black',
              },
            },
            data: this.userData,
            animationDuration: 8000,
            animationEasing: 'quadraticOut',
          },
          {
            name: 'Percentage',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            symbolSize: 10,
            itemStyle: {
              color: 'yellow',
              Style: {
                color: 'yellow',
              },
            },
            label: {
              show: true,
              fontSize: 15,
              color: 'black',
              position: 'top',
              formatter: '{c} %',
            },
            tooltip: {
              formatter: '{a} <br/>{b}: {c}%',
            },
            data: this.userDataPercentage,
            animationDuration: 8000,
            animationEasing: 'quadraticOut',
          },
        ],
      } as EChartOption<EChartOption.SeriesLine>)
    }
  }
}
